var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-navigation'),_c('div',{class:[
      'view'
    ]},[_c('transition',{attrs:{"name":"fade-slow","mode":"out-in"}},[_c('router-view')],1)],1),(false)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }